"use strict";

const tracking = require('dibs-tracking');

const GalleryStore = require('../stores/GalleryStore');
const GalleryModalStore = require('./GalleryModalStore.es');

const galleryActions = require('../actions/galleryActions.es');

function setupStoreWithServerVars(ac, payload, done) {
    ac.dispatch('gallery-modal:setup-store', payload);
    done();
}

function fetchGalleryTemplate(ac, payload, done) {
    const galleryStore = ac.getStore(GalleryStore);
    const galleryUrl = galleryStore.getFetchModalFullUrl(payload);

    fetch(galleryUrl)
        .then(response => response.text())
        .then(template => {
            ac.dispatch('gallery-modal:fetched', {template});
            done();
        })
        .catch(() => {
            ac.dispatch('gallery-modal:hide');
            done();
        });
}

function conditionallyFetchCurrentPhotoGalleryTemplate(ac, {}, done) {

    if (ac.getStore(GalleryModalStore).shouldFetchTemplate()) {

        ac.executeAction(fetchGalleryTemplate, {
            galleryUrl: ac.getStore(GalleryStore).getCurrentPhotoUrl()
        }, done);
    }
}

function fireOriginalVPV(ac, payload, done) {
    const galleryModalStore = ac.getStore(GalleryModalStore);

    // Need to reset the dataLayer (before page view!)
    tracking.addGTMMessage(
        Object.assign({}, galleryModalStore.getOriginalDataLayerInfo(), {
            countOfItems: null
        })
    );

    tracking.trackPageview({
        url: galleryModalStore.getOriginalVPVString()
    });
    done();
}

function showModal(ac, payload, done) {
    ac.dispatch('gallery-modal:show');
    ac.executeAction(conditionallyFetchCurrentPhotoGalleryTemplate);
    done();
}

function hideModal(ac, payload, done) {
    ac.dispatch('gallery-modal:hide');
    ac.executeAction(fireOriginalVPV);
    ac.executeAction(galleryActions.showDetailsMobile, {showDetails: false});
    done();
}

function resetModal(ac, payload, done) {
    ac.dispatch('gallery-modal:reset');
    done();
}

module.exports = {
    setupStoreWithServerVars,
    fetchGalleryTemplate,
    conditionallyFetchCurrentPhotoGalleryTemplate,
    showModal,
    hideModal,
    resetModal
};



// WEBPACK FOOTER //
// ./assets/js/gallery/modal/galleryModalActions.es.js